export const introMyself = `
Hello!
I'm Thi
`


// WEBPACK FOOTER //
// ./src/constants.js